module.exports = __webpack_public_path__ + "img/maintenance-rocket.73d18ac4.png";